import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "core/redux/store/store";

import { fetchNotification } from "./notificationAPI";
import { INotificationData } from "./notificationSliceInterfaces";
import { INotiticheUtente } from "core/interfaces/data/INotificheUtente";

const initialState: INotificationData = {
	notications: [],
	unreadNotification: 0,
	status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("notification/fetchNotification", async (notification: INotificationData) => {
	const response = await fetchNotification(notification);
	// The value we return becomes the `fulfilled` action payload
	return response.data;
});

export const notificationSlice = createSlice({
	name: "notification",
	initialState,
	// The `reducers` field lets us define reducers and generate associated actions
	reducers: {
		setNotification: (state: INotificationData, action: PayloadAction<INotiticheUtente[]>) => {
			state.notications = action.payload.sort((x: INotiticheUtente, y: INotiticheUtente) => {
				if (x.IdNotification < y.IdNotification) {
					return 1;
				} else {
					return -1;
				}
			});
			state.unreadNotification = action.payload.filter((n) => !n.Letto).length;
		},
	},
	// The `extraReducers` field lets the slice handle actions defined elsewhere,
	// including actions generated by createAsyncThunk or in other slices.
	extraReducers: (builder) => {
		builder
			.addCase(incrementAsync.pending, (state) => {
				state.status = "loading";
			})
			.addCase(incrementAsync.fulfilled, (state, action) => {
				state.status = "idle";
				state = action.payload;
			})
			.addCase(incrementAsync.rejected, (state) => {
				state.status = "failed";
			});
	},
});

export const { setNotification } = notificationSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectNotification = (state: RootState) => state.notification;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
// 	(amount: number): AppThunk =>
// 	(dispatch, getState) => {
// 		const currentValue = selectCount(getState());
// 		if (currentValue % 2 === 1) {
// 			dispatch(incrementByAmount(amount));
// 		}
// 	};

export default notificationSlice.reducer;
